// import Cookies from 'universal-cookie'
import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import {initReactI18next} from 'react-i18next'

// Detect current language in a cookie
// const cookies = new Cookies();
// const langCookie = cookies.get('lang');

// Detect current browser language
const langNavigator = navigator.language || navigator.userLanguage;
const langNavigatorSliced = langNavigator.slice(0, 2);

const pathArray = window.location.pathname.split('/');
const pathArrayLang = pathArray[1];

// const lang = langCookie ? langCookie : langNavigatorSliced
let lang;

if (pathArrayLang === 'en') {
  lang = 'en'
} else if (langNavigatorSliced !== 'it' && pathArrayLang === 'en') {
  lang = 'en'
} else {
  lang = 'it'
}

import {version} from '../../../package.json';

i18n.use(Backend).use(initReactI18next).init({
  lng: lang,
  fallbackLng: 'en',
  load: 'languageOnly',
  backend: {
    loadPath: '/assets/i18n/{{ns}}/{{lng}}.json?v='+version
  },
  debug: false,
  ns: [
    'menu',
    'formati',
    'il-viaggio-dell-acqua',
    'home',
    'il-miracolo-della-natura',
    'storia',
    'sostenibilita',
    'azienda-gruppo-ferrarelle',
    'azienda-certificazioni',
    'azienda-acque-minerali',
    'azienda-contatti',
    'impegno-persone',
    'impegno-cultura',
    'impegno-ambiente',
    'cookies',
    'privacy-policy',
    'informazioni-societarie',
    'error-pages',
    'concorso-me-contro-te',
    'concorso-policy',
    'concorso-declinazione-responsabilita',
    'tables',
    'progetto-scuola',
    'ferrarelle-maxima',
    'idg'
  ],
  defaultNS: 'menu',
  keySeparator: false,
  interpolation: {
    escapeValue: false,
    formatSeparator: ','
  },
  react: {
    wait: true
  }
});

// Set language in html tag
if (typeof document !== 'undefined') {
    document.documentElement.lang = lang;
}

// // Redirect in misaligned situations to english translation
// if ((lang !== 'it') && window.location.pathname === '/') {
//   window.location.replace("/en");
// }
//
// // Redirect in misaligned situations to english translation
// if ((lang === 'it') && window.location.pathname === '/en') {
//   window.location.replace("/");
// }

export default i18n
